import { ID, IMenuItem, LOGIN_MODE } from "@libs/interfaces/layouts"
import { default_login, getRoute, login, mainMenu, moduleExists, template } from "@libs/layouts"
import { LayoutIcon } from "@libs/useful"
import { Widgets, __, isCapability } from "@libs/utilities"
import { useSwipe } from "@/modules/pe-basic-module/hooks/useSwipe"
import { ILayoutStore, IState, useLayoutStore, useMainStore } from "@/settings/zustand"
import { Button, Popover, PopoverInteractionKind } from "@blueprintjs/core"
import { Fragment, useEffect, useState } from "react"
import { useLocation } from "react-router"
import { Link, NavLink } from "react-router-dom"
import { isRouteOpen } from "../utils/isRouteOpen"
import LayoutHeaderHeader from "./LayoutHeaderHeader"
import LayoutUnLoginnedExternal from "./login/LayoutUnLoginnedExternal"
import UserMobile from "./login/UserMobile"

const LayoutHeaderMobile = (): JSX.Element => { 
    const [swipeDirection, setSwipeDirection] = useState<"up" | "down" | "">("up")
     
    const up = ():void => {
        //console.log("up")
        setSwipeDirection("up")
    } 
    const down = ():void => {
        //console.log("down")
        setSwipeDirection("down")
    } 
    //const scrollDirection = useScrollDirection() 
    useSwipe({ up, down, })
    const user = useMainStore(( state: IState ) => state.user)  
    const fixMobileTop:boolean = useLayoutStore((state:ILayoutStore) => state.fixMobileTop)

    const mainMenuItems: any[] = mainMenu()
        .filter( e => !e.is_hidden  && moduleExists( e.module ) )
        .filter( e => !isCapability(e.capability, user) )
        .filter( e => !( e.islogged === true && !user.id ) ) 
        .filter( (e, i) => i < 3 )
        .map( ( e, i ) => <MenuItem item={e} i={i} key={ "" + i + e.id }/> )
    return  <>
        <div 
            className={`
                pe-layout-header-mobyle 
                iconic  
                ${ 
                    !fixMobileTop && 
                    ( swipeDirection !== "down" ) 
                        ? 
                        "open"
                        : 
                        "closing" 
                    }
                `
            }>
            <LayoutHeaderHeader />
            <LayoutUserPanel/>
        </div> 
        <div 
            className="pe-layout-menu-mobile-dummy"
            style={{ 
                minHeight: !fixMobileTop && 
                    ( swipeDirection !== "down" ) 
                        ? 
                        75 
                        : 
                        0,
                transition: "all 500ms ease-out"
            }}
        />
        
        <div 
            className={`
                pe-layout-header-menu-mobyle
                d-flex 
                ${ !fixMobileTop && ( swipeDirection === "down" ) 
                    ? 
                    "open"
                    : 
                    "closing" 
                }                
            `}
        >
            <Widgets areaName="before-header-menu" data={{}} /> 
            { mainMenuItems }  
            <MenuPopover />
            <Widgets areaName="after-header-menu" data={{}} />
        </div>
    </>
} 
export default LayoutHeaderMobile


const LayoutUserPanel = ( ) => {
    const user = useMainStore(( state: IState ) => state.user)
    const location = useLocation()
    return user?.id 
        ? 
        <UserMobile />
        : 
        default_login() === LOGIN_MODE.LOGIN 
            ?
            <>
                <Link 
                    state={{ pathname: location.pathname }}
                    className={`icon-unlogined ml-4 ${template().header_menu}`} 
                    style={{minWidth:40}}
                    to={login()} 
                > 
                    <i className="fas fa-sign-in-alt mb-auto "></i> 
                </Link>
                <LayoutUnLoginnedExternal />
            </>
            
            :
            <LayoutUnLoginnedExternal />
}


interface IMenuItemElement {
    item: IMenuItem
    i: number
}
const MenuItem = ({item, i}: IMenuItemElement) => { 
    const landId:ID = useMainStore( ( state: IState ) => state.landId )  
    const event_types: string[] =  useMainStore( ( state: IState ) => state.event_types || [] ) 
    const [isOpen, setIsOpen] = useState<boolean>(isRouteOpen(item, landId, event_types))
    useEffect(() => {
        setIsOpen( isRouteOpen(item, landId, event_types) )
    }, [ item, landId, event_types ])
    const onRoute = ( ) => {

    }   
    if (item.children && item.children.length > 0) {  
        return <Fragment> 
                <NavLink 
                    onClick={ () => onRoute() }
                    to={ { pathname: `/${ getRoute(item) }`  } }
                    key={ i }
                    className={`pt-1 mobyle-main-menu-link ${ isOpen ? "opened" : "closed" }`}  
                >
                    <div className={ `header-menu-element ${ template().header_menu }` }>
                        <LayoutIcon
                            src={ item.icon }
                            className="header-menu-icon"
                            style={{ width: 40, height: 40 }}
                        />
                    </div>
                    <div className="pe-mobyle-under-menu-arrow" />
                    <div className="pe-mobyle-under-menu-label">
                        {__(item.title)}
                    </div>
                </NavLink> 
            </Fragment>
    } 
    return (
        <NavLink 
            //onClick={ () => onRoute( item ) }
            to={ { pathname: `/${ getRoute(item) }` } }
            key={ i }
            className={` mobyle-main-menu-link ${ isOpen ? "opened" : "closed" }`}
        >
            <div className={ `header-menu-element ${ template().header_menu }` }>
                <LayoutIcon
                    src={ item.icon }
                    className="header-menu-icon"
                    style={{ width: 40, height: 40 }}
                /> 
            </div>
            <div className="pe-mobyle-under-menu-label">
                {__(item.title)}
            </div>
        </NavLink>
    )
} 

const MenuPopover = (props: any) : JSX.Element | false => {
    const user = useMainStore(( state: IState ) => state.user)    
    const mainMenuItems: any[] = mainMenu()
        .filter( e => !e.is_hidden  && moduleExists( e.module ) )        
        .filter( e => !isCapability(e.capability, user) )
        .filter( e => !( e.islogged === true && !user.id ) ) 
        .filter((e, i) => i >= 3 )
        .map(( e, i ) => <MenuItem item={e} i={i} />) 

    const widgets = <Widgets areaName="after-header-menu" data={{}} />
    return ( !!mainMenuItems.length ) &&
    <>
        <div className="w-100" />
        <Popover 
            interactionKind={PopoverInteractionKind.CLICK}
            modifiers={{
                arrow: { enabled: false },
                flip: { enabled: true },
                preventOverflow: { enabled: false },
            }}
            content={<div className="pe-mobile-popover-menu">
                { mainMenuItems }
                { widgets }
            </div>}
        >
            <Button
                className=" pt-1 mobyle-main-menu-link m-0 px-0"
                variant="minimal"
            >
                <div className={ `header-menu-element ${ template().header_menu }` }>
                    <LayoutIcon
                        src={ "fas fa-ellipsis-v" }
                        className="header-menu-icon"
                        style={{ width: 20, height: 20 }}
                    /> 
                </div>
                <div className="pe-mobyle-under-menu-label">
                    {__("Also")}
                </div>
            </Button>
        </Popover>
    </>
        
}